<template>
	<div class="selection-criteria-wrapper">
		<div class="login-img" @click="$router.push('/')">
			<img src="@/assets/images/registerLogin.png" alt="">
		</div>
		<div class="progress-bar main">
			<div :style="progressBarStyle"></div>
		</div>

		<div class="content-wrapper">
			<!-- Step 1 -->
			<div v-if="currentStep === 1">
				<div class="business-status">{{titles.title1}}  </div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 1 }" 
					@click="selectButton(1,'ifopen','是')">
						是的，在經營中</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 2 }"
						@click="selectButton(2,'ifopen','否')">不是，尚未開始</button>
				</div>
			</div>

			<!-- Step 2 -->
			<div v-if="currentStep === 2">
				<div class="selection-wrapper main">
					<div class="business-status">
						{{titles.title2}}  
						<div class="small-tips">（可選多項）</div>
					</div>

					<div class="selection-row">
						<div v-for="(item, index) in items" :key="index" class="selection-item"
							:class="{ 'selected': selectedItems.includes(item) }" @click="toggleSelection(item)">
							{{ item }}
						</div>
						<div class="selection-item-box"></div>
						<div class="selection-item-box"></div>
						<div class="selection-item-box"></div>
						<div class="selection-item-box"></div>
					</div>
				</div>
			</div>

			<!-- Step 3 -->
			<div v-if="currentStep === 3">
				<div class="business-status">{{titles.title3}}  </div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 1 }" 
					@click="selectButton(1,'numbers','1')">
						1人</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 4 }"
						@click="selectButton(4,'numbers','2-3人')">2-3人</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 5 }"
					 @click="selectButton(5,'numbers','4-5人')">
						4-5人</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 6 }"
						@click="selectButton(6,'numbers','6-10人')">6-10人</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 7 }" 
					@click="selectButton(7,'numbers','11-20人')">
						11-20人</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 8 }"
						@click="selectButton(8,'numbers','多於21人')">多於21人</button>
				</div>
			</div>

			<!-- Step 4 -->
			<div v-if="currentStep === 4">
				<div class="business-status">{{titles.title4}}  </div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 1 }" 
					@click="selectButton(1,'iflive','有')">
						有試過</button>
				</div>
				<div class="button-wrapper">
					<button :class="{ 'custom-button': true, 'selected': selectedButton === 2 }"
						@click="selectButton(2,'iflive','无')">沒有試過</button>
				</div>
			</div>

			<button class="next-button" @click="nextStep">下一步</button>
		</div>
	</div>
</template>
  
<script>
export default {
	data() {
		return {
			titles:[],
			email:'',
			selectdata:[],
			currentStep: 1,
			selectedButton: null,
			items: [], // 示例数据，可根据需求修改
			selectedItems: [] ,// 存储选中的项,
			formData: {
				email: '',
				ifopen: '',
				product: '',
				numbers: '',
				iflive: '',
				sjk: 'diaoyan'
			},
		}
	},
	computed: {
		progressBarStyle() {
			const stepWidth = 100 / 4;
			return {
				width: `${stepWidth * this.currentStep}%`,
				height: '8px',
				left: '0',
				top: '-0.03rem',
				background: '#E02E43',
				borderRadius: '8rem',
				position: 'absolute'
			};
		}
	},
	mounted() {
		this.backStr = this.$getStorage('localdata')
		console.log('backStr',this.backStr)
		this.formData.email   = this.backStr.submitForm.email
		this.getData()
	
	},

	methods: {
		async getData() {
			let fdata = { do: 'getset', goto: 'after_reg', limit: 15 }
			let res = await this.$api.funk(fdata)
			this.titles = res
			this.items =  res.chanpinlist.split(',') 
			console.log(this.titles)
			
		},
		
		gotologin(){
			window.location.href = 'https://merchants.loopshop.com.hk/'
		},
		
		async nextStep() {
			if (this.currentStep < 4) {
				this.currentStep++;
			}else{
				let res = await this.$api.register(this.formData)
				console.log('res',res)
				this.gotologin()
			}
		},
		selectButton(buttonNumber,field,value) {
			console.log(buttonNumber)
			this.selectedButton = buttonNumber;
			this.formData[field] = value;
			console.log(this.formData)
		},
		toggleSelection(item) {
			if (this.selectedItems.includes(item)) {
				// 如果已经选中，则取消选中
				this.selectedItems = this.selectedItems.filter(selectedItem => selectedItem !== item);
			} else {
				// 如果未选中，则添加到选中项
				this.selectedItems.push(item);
			}
			console.log(this.selectedItems)
			this.formData.product = this.selectedItems.join(',');
			console.log(this.formData)
		}
	}
}
</script>
  
<style lang="scss" scoped>
.selection-criteria-wrapper {
	padding: 0.24rem 0.24rem 0.24rem 0.4rem;

	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		// height: 100vh;
	}

	.login-img {
		position: absolute;
		left: 0;
		top: 0;
		cursor: pointer;

		img {
			margin-top: 0.16rem;
			margin-left: 0.40rem;
			width: 1.04rem;
			height: 0.48rem;
			display: block;
		}
	}

	.progress-bar {
		height: 2px;
		left: 0;
		top: 0;
		// border: 2px solid #E02E43;
		background: #E02E43;
		margin: 0 auto;
		margin-top: 0.8rem;
		border-radius: 0.08rem;
		position: relative;
	}

	.small-tips {
		font-family: 'PingFang HK';
		font-style: normal;
		font-weight: 400;
		font-size: 0.16rem;
		line-height: 0.22rem;
		text-align: center;
		color: #000000;
		width: 100%;
	}

	.content-wrapper {
		text-align: center;

		.business-status {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			text-align: center;
			color: #000000;
			margin-top: 1rem;
			margin-bottom: 0.4rem;
		}

		.button-wrapper {
			display: block;
			margin-bottom: 0.4rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.2rem;
			line-height: 0.28rem;
			color: #000000;

			/* 添加间距，可根据需要调整 */
			.custom-button {
				width: 6.30rem;
				height: 0.8rem;
				background: #FAFAFA;
				border: 1px solid #999999;
				border-radius: 0.08rem;
				text-align: left;
				padding-left: 0.24rem;
				font-size: 0.2rem;
			}

			.custom-button.selected {
				background: rgba(224, 46, 67, 0.1);
				border: 0.04rem solid #E02E43;
				text-align: left;
				padding-left: 0.24rem;
			}



		}

		.selection-wrapper {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: center;
			// margin-left: -0.16rem;
			// margin-bottom: -0.16rem;
		}

		.selection-row {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 0 2.9rem;
			width: 100%;
		}

		.selection-item {
			width: 1.28rem;
			height: 0.76rem;
			margin-bottom: 0.16rem;
			background: #FAFAFA;
			border: 1px solid #999999;
			border-radius: 0.08rem;
			cursor: pointer;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.2rem;
			line-height: 0.76rem;
			color: #000000;
		}

		.selection-item-box {
			width: 1.28rem;
			height: 0.1rem;
			margin-bottom: 0.16rem;
		}

		.selection-item.selected {
			/* 添加选中样式，根据需要自定义 */
			background: rgba(224, 46, 67, 0.1);
			border: 0.04rem solid #E02E43;
		}

		.next-button {
			margin-top: 1rem;
			width: 6.30rem;
			height: 0.8rem;
			background: #E02E43;
			border-radius: 0.08rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.24rem;
			line-height: 0.32rem;
			color: #FFFFFF;
			cursor: pointer;
		}
	}
}

@media (max-width: 750px) {

	.selection-criteria-wrapper {
		display: block;
		height: auto;
		padding-top: 1rem;
	}

	.selection-criteria-wrapper .content-wrapper .selection-row {
		padding: 0;
	}

	.selection-criteria-wrapper .content-wrapper .next-button {
		margin: 0;
	}
}
</style>
  